export const SITE = {
  name: "Liderança com Valores",
  shortName: "Liderança com Valores",
  tagline:
    "Conteúdo de qualidade para líderes, empresas e empreendedores nos tempos atuais.",
  description:
    "Plataforma editorial independente com artigos, análises e guias sobre liderança, gestão, estratégia, cultura organizacional, empreendedorismo e crescimento sustentável para empresas e profissionais.",
  baseUrl: "https://liderancacomvalores.com.br",
  email: "contato@liderancacomvalores.com.br",
  social: {
    instagram: "https://www.instagram.com/",
    linkedin: "https://www.linkedin.com/",
    facebook: "https://www.facebook.com/",
  },
};

export const NAV = [
  { to: "/", label: "Início" },
  { to: "/blog", label: "Artigos" },
  { to: "/sobre", label: "Sobre" },
  { to: "/equipe", label: "Time editorial" },
  { to: "/contato", label: "Contato" },
] as const;
